export const FIND_JOBS_LIST = [
  '3D Animator',
  'Animator',
  'Digital Marketer',
  'Graphic Designer',
  'Illustrator',
  'Mixing Engineer',
  'Motion Graphic Designer',
  'Music Composer',
  'Music Producer',
  'Photographer',
  'SEO Expert',
  'Social Media Freelancer',
  'UI Designer',
  'UX Designer',
  'Video Editor',
  'Videographer',
  'Vocalist',
  'Voiceover Artist',
  'Web Designer',
  'Web Developer',
];

export const FIND_COUNTRIES_LIST = [
  'United States',
  'United Kingdom',
  'Italy',
  'Canada',
  'Singapore',
  'Australia',
  'United Arab Emirates',
  'Philippines',
  'Germany',
  'Malaysia',
  'Netherlands',
  'Ireland',
  'South Africa',
  'Spain',
  'France',
  'Portugal',
  'Thailand',
  'Sweden',
  'Switzerland',
  'Japan',
];
